import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Box, Typography, Button } from '@mui/material';
import Imagen1 from '../assets/bombero-h.jpg';
import Imagen2 from '../assets/drone.jpg';
import { isMobile, isDesktop } from 'react-device-detect';

const Portada = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { arrows: false },
      },
      {
        breakpoint: 768,
        settings: { arrows: false, dots: false },
      },
    ],
  };

  const slides = [
    {
      imagen: Imagen1,
      titulo: '¿Necesitás la habilitación de Bomberos para tu local o proyecto?',
      descripcion: 'Nos encargamos de todo el proceso técnico y documental para que cumplas con la normativa sin complicaciones.',
      botonTexto: 'Pedir cotización',
      botonLink: '/#contacto',
    },
    {
      imagen: Imagen2,
      titulo: '¿Buscás imágenes aéreas profesionales?',
      descripcion: 'Capturá tu proyecto desde otro ángulo. Realizamos filmaciones y fotografías aéreas con drones en alta resolución.',
      botonTexto: 'Pedir cotizacion',
      botonLink: '/#contacto',
    }
  ];

  return (
    <Box sx={{ marginTop: '86px', height: '100vh', maxWidth:'100vw' }}>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <Box key={index} sx={{ position: 'relative', width: '100%', height: '100vh' }}>
            {/* Imagen de fondo con overlay */}
            <Box
              component="img"
              src={slide.imagen}
              alt={`Imagen ${index + 1}`}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            {/* Overlay */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                
                
              /*   padding: '20px' */
              }}
            >
              <Box sx={{ 
                top: 0,
                width: isDesktop ?'50%':'94%',
                maxWidth: !isDesktop ? '700px': "800px",
                height: '70%',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft:isMobile ? '20px':'100px',
                justifyContent: 'center',
                alignItems:'flex-start',
                color: 'white',
                textAlign: 'start'}}>
              <Typography variant="h1" textTransform='uppercase' sx={{fontSize:!isDesktop ? '2rem': '3rem'}} fontWeight="bold" gutterBottom>
                {slide.titulo}
              </Typography>
              <Typography variant="h6"  mb={3}>
                {slide.descripcion}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                href={slide.botonLink}
                sx={{ backgroundColor: '#6699ff', '&:hover': { backgroundColor: '#3aa469' } }}
              >
                {slide.botonTexto}
              </Button>
              </Box>
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default Portada;
